<template>
  <!-- 手动上传，覆盖默认上传，用于上传后直接后端直接返回文件流处理 -->
  <div class="manually-upload">
    <div style="width:500px;">
      <file-upload
        ref="fileUploadHook"
        isNeedAuthpority
        :resetFlag="visible"
        downloadTplTip="下载导入模板"
        autoUploadConfirmTxt="确定导入"
        @success="importSuccess"
        @download-err-excel="downloadTpl"
        @download-tpl="downloadTpl"
        @cancel="()=>{
          this.$refs.fileUploadHook.reset();
          $emit('cancel');
        }"
        :uploadFileUrl="uploadFileUrl"
        :title="''"
        :uploadData="uploadData"
        fileTypeLimit="xlsx"
        accept=".xlsx"
        :httpRequest="httpRequest"
      ></file-upload>
    </div>
  </div>
</template>

<script>
import { FileUpload } from '@/components/upload';
import fileDownloadMixins from '@/mixins/file-download';
import http from '@/utils/request';

export default {
  name: 'ImportGoods',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    uploadFileUrl: {
      type: String,
      default: '',
    },
    uploadData: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [fileDownloadMixins],
  components: {
    FileUpload,
  },
  data() {
    return {
    };
  },
  methods: {
    // 导入成功
    importSuccess(res) {
      this.$emit('success', res);
      this.$message.success('操作完成');
    },
    // 下载模板
    downloadTpl() {
      this.$emit('downloadTpl');
    },
    // 自定义上传
    httpRequest(item) {
      const formData = new FormData();
      formData.append('fileUpload', item.file);
      http.post({
        url: item.action,
        responseType: 'blob', // 不可省，非常重要
        'Content-Type': 'multipart/form-data',
        data: formData,
      }).then((res) => {
        const response = res?.data;
        if (response.type === 'application/json') {
          const reader = new FileReader();
          reader.readAsText(response, 'utf-8');
          reader.onload = () => {
            let result = '';
            try {
              result = JSON.parse(reader.result);
            } catch (e) {
              console.log(e);
              result = response;
            }
            this.$message.error((result && result.message) || '导出失败');
            this.$refs.fileUploadHook.uploadCode = 10;
          };
        } else {
          const fileName = window.decodeURI(res.headers['content-disposition'].split('=')[1]);
          this.$refs.fileUploadHook.uploadSuccess({
            code: '200', data: res.data, ...res.headers, fileName,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.intro-wrap {
  padding-left: 10px;
  h3 {
    line-height: 1.5;
    color: #909399;
    font-weight: bold;
  }
  p {
    line-height: 1.5;
    color: #909399;
    text-indent: 10px;
  }
}
</style>
